import {initializeApp} from 'firebase/app';
import {getAuth} from 'firebase/auth';
import {getFirestore, initializeFirestore} from 'firebase/firestore';
import {getDatabase} from 'firebase/database';

const firebaseConfigDev = {
    apiKey: "AIzaSyAhTNQtW2bZLSK0OytTfG5iHGxJU28GbVM",
    authDomain: "addy-ai-dev.firebaseapp.com",
    databaseURL: "https://addy-ai-dev-default-rtdb.firebaseio.com",
    projectId: "addy-ai-dev",
    storageBucket: "addy-ai-dev.appspot.com",
    messagingSenderId: "111911035666",
    appId: "1:111911035666:web:f3416d1edca6e2d48209cb",
    measurementId: "G-KGZSR9LWED"
};
const firebaseConfigProd = {
    apiKey: "AIzaSyCDBO1NWURhFlBZpd1Bxc2pxUPhV8k8LMQ",
    authDomain: "hey-addy-chatgpt.firebaseapp.com",
    databaseURL: "https://hey-addy-chatgpt-default-rtdb.firebaseio.com",
    projectId: "hey-addy-chatgpt",
    storageBucket: "hey-addy-chatgpt.appspot.com",
    messagingSenderId: "284266859441",
    appId: "1:284266859441:web:9d4598d5872ea944410b90",
    measurementId: "G-C1K8WJ7R6F"
};

let appDev;
let appProd;
let authDev;
let authProd;
let firestoreDev;
let firestoreProd;
let databaseDev;
let databaseProd;

try {
    // Initialize apps with unique names
    appDev = initializeApp(firebaseConfigDev, 'dev');
    appProd = initializeApp(firebaseConfigProd, 'prod');

    // Initialize Firestore with settings
    firestoreDev = initializeFirestore(appDev, {
        experimentalForceLongPolling: true,
        useFetchStreams: false,
    });
    firestoreProd = initializeFirestore(appProd, {
        experimentalForceLongPolling: true,
        useFetchStreams: false,
    });

    // Get other services
    authDev = getAuth(appDev);
    authProd = getAuth(appProd);

    databaseDev = getDatabase(appDev);
    databaseProd = getDatabase(appProd);

} catch (error) {
    console.error("Firebase initialization error:", error);
    throw error; // Re-throw to prevent app from running with broken Firebase
}

export {appDev, appProd, authDev, authProd, firestoreDev, firestoreProd, databaseDev, databaseProd};
